(function($) {
    gsap.registerPlugin(ScrollTrigger);

    let block = document.querySelector('.block-featured-projects');
    if( block ) {

        let scrollcontainer = block.querySelector('.scroll-container');
        let swipercontainer = block.querySelector('.swiper-container');

        //
        //  Scroll container
        //

        let sections = gsap.utils.toArray(".scroll-panel");

        function calc_dimensions() {
            let slowdown_factor = 2.5;
            let margins = scrollcontainer.getBoundingClientRect().left * 2;
            let gap = 30; // Replace with dynamic calculation if needed
            let sections_total_width = 0;

            sections.forEach((section) => {
                sections_total_width += section.offsetWidth;
            });

            let end =
                sections_total_width +
                (sections.length - 1) * gap -
                window.innerWidth +
                margins;
            let x = end;

            return {
                end: end * slowdown_factor,
                x: -x,
            };
        }

        function setupScrollAnimation() {
            ScrollTrigger.getAll().forEach((trigger) => trigger.kill()); // Clear previous triggers
            gsap.to(sections, {
                x: () => calc_dimensions().x,
                ease: "none",
                scrollTrigger: {
                    trigger: ".scroll-container",
                    pin: true,
                    scrub: 0.1,
                    end: () => calc_dimensions().end,
                    invalidateOnRefresh: true,
                },
            });
        }

        setupScrollAnimation();

        //
        //  Swiper container
        //

        const blockswiper = new Swiper( swipercontainer, {
            slidesPerView: 'auto',
            freeMode : true,
            spaceBetween: 45,
            centeredSlides: false,
            navigation: false
            // {
            //     nextEl: '.swiper-button-next',
            //     prevEl: '.swiper-button-prev',
            // },
        });

    }
})(jQuery);
